export default __webpack_public_path__ + "static/media/iconAyuda.6882c729.svg";